// The wordmark artwork carries its own opaque background and spells the name
// wrong, so it is not used anywhere. The lockup is the icon on its own dark
// tile with "Globilise" set in type beside it.
const SIZES = {
  sm: { gap: "gap-2.5", tile: "h-9 w-9 rounded-xl",   name: "text-[15px]", tagline: "mt-1 text-[10px]" },
  lg: { gap: "gap-3.5", tile: "h-12 w-12 rounded-2xl", name: "text-[26px]", tagline: "mt-1.5 text-[11px]" },
};

const TONES = {
  light: { name: "text-gray-900", tagline: "text-gray-400",      ring: "" },
  dark:  { name: "text-white",    tagline: "text-brand-100/70",  ring: "ring-1 ring-white/15" },
};

const BrandMark = ({
  compact = false,
  size = "sm",
  tone = "light",
  tagline = false,
  className = "",
}) => {
  const s = SIZES[size] ?? SIZES.sm;
  const t = TONES[tone] ?? TONES.light;

  return (
    <span className={`flex items-center ${s.gap} ${className}`}>
      <span className={`grid shrink-0 place-items-center overflow-hidden bg-gray-900 ${s.tile} ${t.ring}`}>
        <img src="/globilise-icon.png" alt="" className={`object-cover ${s.tile}`} />
      </span>

      <span
        className={`overflow-hidden whitespace-nowrap transition-all duration-300
          ${compact ? "w-0 opacity-0" : "w-auto opacity-100"}`}
      >
        <span className={`block font-semibold leading-none tracking-tight ${s.name} ${t.name}`}>
          Globilise
        </span>
        {tagline && (
          <span className={`block font-medium uppercase tracking-[0.16em] ${s.tagline} ${t.tagline}`}>
            Translation Operations, Simplified.
          </span>
        )}
      </span>
    </span>
  );
};

export default BrandMark;
